import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { CrossIcon } from '../../../../../../shared/components/icons/nav/CrossIcon'
import { MenuIcon } from '../../../../../../shared/components/icons/nav/MenuIcon'
import { useAuth } from '../../../../../../shared/lib/hooks/UseAuth'
import { useMenuLayout } from '../../../hooks/UseMenuLayout'
import { MAIN_NAVIGATION, SERVICE_NAVIGATION } from '../Navigation.const'
import { Logotype } from './Logotype'
import { NavMenu } from './NavMenu'
import { TariffButton } from './TariffButton'

const ICON_BUTTON_CLASS =
  'flex h-[44px] w-[44px] items-center justify-center rounded-[8px] bg-default text-white'

export const Header = () => {
  const { pathname } = useLocation()
  const { logout } = useAuth()
  const { switchMenuLayout } = useMenuLayout()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(false)
  }, [pathname])

  const handleAction = (id: string) => {
    switch (id) {
      case 'logout':
        return logout()
      case 'switch-menu':
        return switchMenuLayout('top')
    }
  }

  return (
    <div className={'flex w-full items-center justify-between bg-focus-500 p-[16px]'}>
      {/* Logotype тянется на всю ширину, поэтому в строке ему нужна обёртка по содержимому */}
      <div>
        <Logotype />
      </div>
      <div className={'flex gap-[16px]'}>
        <TariffButton collapsed />
        <button className={ICON_BUTTON_CLASS} onClick={() => setIsOpen(true)}>
          <MenuIcon />
        </button>
      </div>
      {/* Меню занимает слот лэйаута: inset-0 считается от него, бары main layout остаются видны */}
      <div
        className={clsx(
          'absolute inset-0 z-30 flex flex-col bg-focus-500 transition-[transform,opacity] duration-200',
          {
            ['translate-x-0 opacity-100']: isOpen,
            // Закрытое меню уезжает за правый край слота и обрезается оболочкой лэйаута
            ['pointer-events-none translate-x-full opacity-0']: !isOpen,
          },
        )}
      >
        <div className={'flex items-center justify-between p-[16px]'}>
          <div>
            <Logotype />
          </div>
          <button className={ICON_BUTTON_CLASS} onClick={() => setIsOpen(false)}>
            <CrossIcon />
          </button>
        </div>
        <div
          className={
            'scrollbar-hide flex min-h-0 flex-1 flex-col gap-[8px] overflow-y-auto p-[8px] pt-0'
          }
        >
          <NavMenu className={'flex flex-1 flex-col'} collapsed={false} items={MAIN_NAVIGATION} />
          <NavMenu
            className={'flex flex-col'}
            collapsed={false}
            items={SERVICE_NAVIGATION}
            onAction={handleAction}
          />
          <TariffButton />
        </div>
      </div>
    </div>
  )
}
